//
//
//
//
//
//

import LargeWebsite from 'components/combinedBlocks/Website.vue'

// import Swipe from 'components/mixins/Swipe.vue'
// import PreventDefault from 'components/mixins/PreventDefault.vue'
// import MouseWheel from 'components/mixins/MouseWheel.vue'

import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  block: 'app',
  components: {
    LargeWebsite,
  },
  mixins: [
    // Swipe,
    // PreventDefault,
    // MouseWheel
  ],
  data() {
    return {
      currentPage: null,
      // currentScreenSize: null,
      inviteToken: null
    }
  },
  computed: {
    ...mapGetters([
      'currentSection',
      // 'sections',
      // 'isPortrait',
      // 'screenSize',
      'isLarge',
      // 'isMedium',
      // 'isSmall',
      'isFetchingData',
      // 'backDrop',
      'language',
      'availableLanguages',
    ]),
  },
  methods: {
    ...mapActions([
      'observeScreenSize',
      // 'observeIfPortrait',
      'fetchData'
    ]),
    ...mapMutations([
      // 'nextSection',
      // 'prevSection',
      'setCurrentSection',
      // 'setIsPortrait',
      // 'setScreenSize',
      // 'setBackDrop',
      'setLanguage',
    ]),
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    tryToFetchData(pageChanged) {
      if(!pageChanged)
        return;

      const inviteToken = this.$route.query.invite;

      const page = this.$route.params.page || 0;
      const currentPage = this.isNumeric(page) ? 'index' : page;
      const sectionIndex = this.$route.params.section || 0;

      this.currentPage = currentPage;
      // this.currentScreenSize = this.screenSize;

      this.fetchData({
        currentPage: currentPage,
        inviteToken: inviteToken,
        done: () => {
          this.setCurrentSection(sectionIndex || 0);
        }
      });
    },
    currentUrl(section) {
      const page = this.$route.params.page || 0;
      const currentPage = this.isNumeric(page) ? '' : '/' + page;
      const sectionIndex = section ? '/' + section : '';

      return (currentPage + sectionIndex);
    },
    parseLang(langCodeOrIndex) {
      if(this.isNumeric(langCodeOrIndex))
        return this.availableLanguages[this.$route.query.lang] || this.availableLanguages[0];

      const lang = this.availableLanguages.find(language => language.code === langCodeOrIndex);
      if(lang)
        return lang;

      return this.availableLanguages[0];
    },
  },
  // created() {
  //   this.inviteToken = this.$route.query.invite;
  // },
  mounted() {
    this.setLanguage(this.parseLang(this.$route.query.lang));

    // const enableUpAndDownArrows = () => {
    //   const upAndDown = (e) => {
    //     if(e.keyCode === 40) this.nextSection();
    //     if(e.keyCode === 38) this.prevSection();
    //   }
    //   document.addEventListener('keydown', upAndDown);
    // }

    // const enableBackAndForwardButtons = () => {
    //   const backAndForward = (e) => {
    //     if(document.activeElement.nodeName !== 'BODY')
    //       return;
    //     if(e.keyCode === 66) this.$router.go(-1);
    //     if(e.keyCode === 70) this.$router.go(1);
    //   }
    //   document.addEventListener('keydown', backAndForward);
    // }

    // const disableDefaultScroll = () => {
    //   if(window.addEventListener)
    //     window.addEventListener('DOMMouseScroll', this.preventDefault, false);
    //   window.addEventListener('wheel', this.preventDefault, false);
    //   window.addEventListener('mousewheel', this.preventDefault, false);
    //   window.addEventListener('mousewheel', this.preventDefault, false);
    //   window.addEventListener('touchmove', this.preventDefault, false);
    // }

    // window.addEventListener('touchmove', () => {console.log("touch scrolling");}, false);

    // disableDefaultScroll();
    // enableUpAndDownArrows();
    // enableBackAndForwardButtons();

    // this.trackMouseWheel(this.nextSection, this.prevSection);
    // this.trackSwipe(this.$el, 'y', this.nextSection, this.prevSection);
    // this.observeIfPortrait();
    this.observeScreenSize();
    this.tryToFetchData(true);

    // window.addEventListener('resize', ()=>this.tryToFetchData(false));
    // window.addEventListener('orientationonchange', ()=>this.tryToFetchData(false));
  },
  watch: {
    $route() {
      const nextPage = this.$route.params.page ? this.$route.params.page : 'index';
      this.tryToFetchData(this.currentPage !== nextPage);
    },
    currentSection(section) {
      this.$router.push(this.currentUrl(section));
    },
    'language.code': function(value) {
      this.tryToFetchData(true);
    }
  }
}



// WEBPACK FOOTER //
// ./components/App.vue